export default {
    appTechnicians: state => state.appTechnicians,
    activeTech: state => state.activeTech,
    manageTechDialog: state => state.manageTechDialog,
    deleteTechDialog: state => state.deleteTechDialog
}
